import {
  ResetPasswordPageReducerAction,
  ResetPasswordPageState
} from 'pages/ResetPassword/types';

export const getInitialState = (): ResetPasswordPageState => ({
  password: '',
  isDirtyPasswordField: false,
  passwordConfirm: '',
  isDirtyPasswordConfirmField: false,
  isPasswordMatching: true,
  invalidKey: '',
  errors: [],
  isLoading: false
});

export const resetPasswordPageReducer = (
  state: ResetPasswordPageState,
  action: ResetPasswordPageReducerAction
): ResetPasswordPageState => {
  switch (action.type) {
    case 'SET_LOADING': {
      return {
        ...state,
        isLoading: true
      };
    }
    case 'SET_PASSWORD_DIRTY': {
      return {
        ...state,
        isDirtyPasswordField: true
      };
    }
    case 'SET_PASSWORD_CONFIRM_DIRTY': {
      return {
        ...state,
        isDirtyPasswordConfirmField: true
      };
    }
    case 'SET_DATA': {
      return {
        ...state,
        isLoading: false,
        data: action.payload.data
      };
    }
    case 'SET_ERRORS': {
      return { ...state, errors: action.payload.errors, isLoading: false };
    }
    case 'SET_PASSWORD': {
      const {
        payload: { password, invalidKey }
      } = action;

      return {
        ...state,
        password,
        invalidKey,
        isPasswordMatching: password === state.passwordConfirm
      };
    }
    case 'SET_PASSWORD_CONFIRM': {
      const {
        payload: { passwordConfirm }
      } = action;

      return {
        ...state,
        passwordConfirm,
        isPasswordMatching: passwordConfirm === state.password
      };
    }
  }
};
